import { defineComponent } from "@vue/runtime-core";
import Breadcrumb from '@/components/navigation/breadcrumb/index.vue'

export default defineComponent({
  name: 'contact',
  components: {
    Breadcrumb
  }
})